import {Component, inject} from '@angular/core'
import {ConfigService, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {BlancoListComponent} from '../blancolist/blanco-list.component'
import {StatisticsComponent} from '../statistics/statistics.component'
import {MatMiniFabButton} from '@angular/material/button'
import {AdminService} from '../../services/admin.service'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {MatFormField, MatLabel} from '@angular/material/form-field'

@Component({
  selector: 'spb-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    StatisticsComponent,
    BlancoListComponent,
    LoginComponent,
    MatIcon,
    MatMiniFabButton,
    MatFormField,
    MatLabel,
    MatInput
  ]
})
export class HomeComponent {
  public readonly configService = inject(ConfigService)
  public readonly adminService = inject(AdminService)
}
